<!-- Destinations -->
<section class="w-full px-4 md:px-8 lg:px-15 bg-white dark:bg-slate-800 pb-10">
    <div class="flex flex-col items-center justify-center">
        <div class="flex flex-col w-full">
            <div class="w-full flex justify-center items-center mb-10">
                <div
                    class="flex flex-col justify-center items-center mt-5 sm:pl-5 sm:pr-5 sm:items-center">
                    <div class="flex flex-col">
                        <div class="w-full flex justify-center items-center">
                            <div class="w-full flex flex-row justify-between items-center">
                                @if (view.site && view.site.profile && view.site.profile.heading) {
                                @switch (view.site.profile.heading.position) {
                                @case (1) {
                                <app-heading_section-type01
                                    [options]="{heading:'Destinations',title:'Premier Destinations',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                                }
                                @case (2) {
                                <app-heading_section-type01
                                    [options]="{heading:'Destinations',title:'Premier Destinations',image:'assets/xltravel/swoosh-01.svg', description:''}"></app-heading_section-type01>
                                }
                                <!-- @case (3) {
                                <app-heading_section-type01 [options]="{heading:'Leisure Travel',title:'',image:'assets/xltravel/swoosh-01.svg', description:''}" ></app-heading_section-type01>
                                } -->
                                @case (4) {
                                <app-heading_section-type01
                                    [options]="{heading:'Destinations',title:'Unforgettable Journeys',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                                }
                                }
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="w-[95%] m-auto " >
                <!-- <ejs-carousel
                    cssClass="h-[40vh]"
                    [showIndicators]="true"
                    [buttonsVisibility]="'VisibleOnHover'"
                    [partialVisible]="false">
                    <e-carousel-items>
                          @for (destination of view.destinations; track destination) {
                        <e-carousel-item>
                            <ng-template  #template>
                                 <a
                                    [routerLink]="[
                                        '/destination',
                                        destination?.id,
                                        destination?.seo.alias
                                    ]"
                                    class="relative  flex flex-col justify-end overflow-hidden rounded-3xl px-8 pb-8 pt-40 mx-auto hover:shadow-xl dark:border-2 dark:border-primary-100">
                                    <img
                                        [src]="destination?.imageUrl"
                                        alt="destination australia"
                                        class="absolute inset-0 h-full w-full object-cover" />
                                    <div
                                        class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                                    <div class="flex flex-col z-10 min-h-10">
                                        <div>
                                            <h3
                                                class="text-primary-500 tracking-wider text-3xl text-left custom_font">
                                                {{ destination.name }}
                                            </h3>
                                        </div>
                                        <div class="flex items-center">
                                            <div class>
                                                <p class="text-white text-md">
                                                    {{ destination.tagline
                                                    }}<span
                                                        class="text-lg text-primary-500"></span>
                                                </p>
                                            </div>
                                            <a class>
                                                <mat-icon
                                                    class="icon-size-8 ring-2 ml-2 ring-primary-500 rounded-full text-primary-500 mt-2 transition transition-duration: 500ms hover:bg-primary-500 hover:text-primary-100"
                                                    [svgIcon]="
                                                        'keyboard_arrow_right'
                                                    "></mat-icon>
                                            </a>
                                        </div>
                                    </div>
                                </a>
                            </ng-template>
                           
                        </e-carousel-item>
                    }
                    </e-carousel-items>
                    <ng-template #previousButtonTemplate let-data>
                        <div class="flex items-center justify-center mr-5 w-15 h-15 cursor-pointer bg-primary-50 group-hover:bg-primary-500 transition ease-out duration-500 border-none rounded-full">
                            <mat-icon   class="icon-size-6 text-primary-500 group-hover:text-primary-100 transition ease-out duration-500" [svgIcon]="'feather:arrow-left'"></mat-icon>
                        </div>
                    </ng-template>
                    <ng-template #nextButtonTemplate let-data>
                         <div class="flex items-center justify-center mr-5 w-15 h-15 cursor-pointer bg-primary-50 group-hover:bg-primary-500 transition ease-out duration-500 border-none rounded-full">
                            <mat-icon   class="icon-size-6 text-primary-500 group-hover:text-primary-100 transition ease-out duration-500" [svgIcon]="'feather:arrow-right'"></mat-icon>
                        </div>
                    </ng-template>
                    <ng-template #indicatorsTemplate let-data>
                        <ng-template #indicatorsTemplate let-data>
                            <div class="w-full">
                                <div class="cursor-pointer w-56 h-24 mx-2 rounded-md b-2 border-primary-300" [style.backgroundSize]="'cover'" [style.backgroundPosition]="'center'" [style.backgroundImage]="'url(' + view.destinations.imageUrl +')'"></div>
                            </div>
                        </ng-template>
                    </ng-template>
                </ejs-carousel> -->
                <ngx-slick-carousel class="carousel" 
                        #slickModal="slick-carousel" 
                        [config]="slideConfig" 
                        (init)="slickInit($event)"
                        (breakpoint)="breakpoint($event)"
                        (afterChange)="afterChange($event)"
                        (beforeChange)="beforeChange($event)">
                        
                        @for (destination of view.destinations; track destination) {
                            <fuse-card ngxSlickItem class="slide mx-2">
                                <a [routerLink]="['/destination', destination.id, destination.seo.alias]" class="relative h-100 flex flex-col justify-end overflow-hidden px-4 md:px-8 lg:px-8 pb-4 md:pb-8 lg:pb-8 pt-40 mx-auto hover:shadow-xl dark:border-0 dark:border-primary-100">
                                    <img [src]="destination.imageUrl" alt="destination" class="absolute inset-0 h-full w-auto object-cover">
                                    <div class="absolute inset-0 bg-gradient-to-t from-gray-700 via-gray-900/40"></div>
                                    <div class="flex flex-col z-10 h-28 min-h-28">
                                        <div class="flex-shrink-0">
                                            <h3 class="text-primary-500 tracking-wider text-3xl text-left custom_font drop-shadow-title">{{destination.name}}</h3>
                                        </div>
                                        <div class="flex items-center flex-1 min-h-0">
                                            <div class="min-w-0 flex-1">
                                                <p class="text-white text-md line-clamp-2 drop-shadow-title">{{destination.tagline}}<span class="text-lg text-primary-500"></span></p>
                                            </div>
                                            <a class="">
                                                <mat-icon class="icon-size-8 ring-2 ml-2 ring-primary-500 rounded-full text-primary-500 mt-2 transition transition-duration: 500ms hover:bg-primary-500 hover:text-primary-100" [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                                            </a>
                                        </div>
                                    </div>
                                </a>
                            </fuse-card>
                        }
            </ngx-slick-carousel>
            </div>

            <!-- <div class="flex flex-row">
            @for (destination of view.destinations; track destination) {
                <a [routerLink]="['/destination', destination.id, destination.seo.alias]" class="relative h-72 w-52 flex flex-col justify-end overflow-hidden rounded-3xl px-8 pb-8 pt-40 mx-auto hover:shadow-xl dark:border-2 dark:border-primary-100">
                    <img [src]="destination.imageUrl" alt="destination australia" class="absolute inset-0 h-full w-full object-cover">
                    <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                    <div class="flex flex-col z-10 min-h-10">
                        <div>
                            <h3 class="text-primary-500 tracking-wider text-3xl text-left custom_font drop-shadow-title">{{destination.name}}</h3>
                        </div>
                        <div class="flex items-center">
                            <div class="">
                                <p class="text-white text-md">{{destination.tagline}}<span class="text-lg text-primary-500"></span></p>
                            </div>
                            <a class="">
                                <mat-icon class="icon-size-8 ring-2 ml-2 ring-primary-500 rounded-full text-primary-500 mt-2 transition transition-duration: 500ms hover:bg-primary-500 hover:text-primary-100" [svgIcon]="'keyboard_arrow_right'"></mat-icon>
                            </a>
                        </div>
                    </div>
                </a>
            }
          </div> -->
            <!-- <div class="control-section db-carousel-section">
            
              <div class="col-lg-12 content-wrapper">
                <div class="carousel-sample">
                  @for (destination of view.destinations; track destination) {
                  <ejs-carousel cssClass="db-carousel"  [buttonsVisibility]="buttonsVisibility"
                    [animationEffect]="carouselAnimation">
                    <ng-template #itemTemplate let-data>
                      <div class="card">
                        <img src="{{destination.imageUrl}}" class="card-img-top" alt="{{data.Title}}" style="height:210px;width:100%;" />
                        <div class="card-body" style="padding:1rem;">
                          <h1 class="card-title">{{destination.name}}</h1>
                          <p class="card-text">{{destination.tagline}}</p>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-carousel>
                   }
                </div>
              </div>
           
          </div> -->
        </div>
    </div>
</section>
